import { useState } from 'react';
import { Box, CssBaseline, Typography, Stack, Button, TextField, IconButton, Popover } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import logoImage from '../static/logo.jpg'
import backgroundImage from '../static/background.png'
import axios from 'axios'
import moment from 'moment-timezone';
import toast, { Toaster } from 'react-hot-toast';

// const eventID = "6a0d871751beac0014246bc6";

const sessionOneId = "6a63448bda9f6e0013d20aa5"
const sessionTwoId = "6a634647da9f6e0013d2144a"
const sourceTimezone = 'Europe/Paris';

const sessions = {
  sessionOne: {
    key: 'sessionOne',
    eventId: sessionOneId,
    label: 'Session 1',
    start: '2026-09-10 09:00',
    end: '2026-09-10 10:00',
  },
  sessionTwo: {
    key: 'sessionTwo',
    eventId: sessionTwoId,
    label: 'Session 2',
    start: '2026-09-10 17:00',
    end: '2026-09-10 18:00',
  },
};

const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';

const formatSession = (session) => {
  const start = moment.tz(session.start, 'YYYY-MM-DD HH:mm', sourceTimezone);
  const end = moment.tz(session.end, 'YYYY-MM-DD HH:mm', sourceTimezone);
  const dateFormatter = new Intl.DateTimeFormat(undefined, {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: browserTimezone,
  });
  const timeFormatter = new Intl.DateTimeFormat(undefined, {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: browserTimezone,
  });
  const timezoneFormatter = new Intl.DateTimeFormat(undefined, {
    timeZone: browserTimezone,
    timeZoneName: 'short',
  });
  const timezoneName = timezoneFormatter
    .formatToParts(start.toDate())
    .find((part) => part.type === 'timeZoneName')?.value;

  return {
    date: dateFormatter.format(start.toDate()),
    time: `${timeFormatter.format(start.toDate())} - ${timeFormatter.format(end.toDate())}`,
    timezone: timezoneName
      ? `${timezoneName} (${browserTimezone})`
      : browserTimezone,
  };
};

// const webcastUrl = `https://stream.brrmedia.co.uk/broadcast/${eventID}`;
// const backgroundVideo = 'https://brrmedia-clients-uploads.s3.us-west-2.amazonaws.com/videos/14949216_3840_2160_60fps.mp4';

// const typeOptions = ['Investor', 'Analyst', 'Other'];

// const countryCodes = [
//   'AF', 'AX', 'AL', 'DZ', 'AS', 'AD', 'AO', 'AI', 'AQ', 'AG', 'AR', 'AM',
//   'AW', 'AU', 'AT', 'AZ', 'BS', 'BH', 'BD', 'BB', 'BY', 'BE', 'BZ', 'BJ',
//   'BM', 'BT', 'BO', 'BQ', 'BA', 'BW', 'BV', 'BR', 'IO', 'BN', 'BG', 'BF',
//   'BI', 'CV', 'KH', 'CM', 'CA', 'KY', 'CF', 'TD', 'CL', 'CN', 'CX', 'CC',
//   'CO', 'KM', 'CG', 'CD', 'CK', 'CR', 'CI', 'HR', 'CU', 'CW', 'CY', 'CZ',
//   'DK', 'DJ', 'DM', 'DO', 'EC', 'EG', 'SV', 'GQ', 'ER', 'EE', 'SZ', 'ET',
//   'FK', 'FO', 'FJ', 'FI', 'FR', 'GF', 'PF', 'TF', 'GA', 'GM', 'GE', 'DE',
//   'GH', 'GI', 'GR', 'GL', 'GD', 'GP', 'GU', 'GT', 'GG', 'GN', 'GW', 'GY',
//   'HT', 'HM', 'VA', 'HN', 'HK', 'HU', 'IS', 'IN', 'ID', 'IR', 'IQ', 'IE',
//   'IM', 'IL', 'IT', 'JM', 'JP', 'JE', 'JO', 'KZ', 'KE', 'KI', 'KP', 'KR',
//   'KW', 'KG', 'LA', 'LV', 'LB', 'LS', 'LR', 'LY', 'LI', 'LT', 'LU', 'MO',
//   'MG', 'MW', 'MY', 'MV', 'ML', 'MT', 'MH', 'MQ', 'MR', 'MU', 'YT', 'MX',
//   'FM', 'MD', 'MC', 'MN', 'ME', 'MS', 'MA', 'MZ', 'MM', 'NA', 'NR', 'NP',
//   'NL', 'NC', 'NZ', 'NI', 'NE', 'NG', 'NU', 'NF', 'MK', 'MP', 'NO', 'OM',
//   'PK', 'PW', 'PS', 'PA', 'PG', 'PY', 'PE', 'PH', 'PN', 'PL', 'PT', 'PR',
//   'QA', 'RE', 'RO', 'RU', 'RW', 'BL', 'SH', 'KN', 'LC', 'MF', 'PM', 'VC',
//   'WS', 'SM', 'ST', 'SA', 'SN', 'RS', 'SC', 'SL', 'SG', 'SX', 'SK', 'SI',
//   'SB', 'SO', 'ZA', 'GS', 'SS', 'ES', 'LK', 'SD', 'SR', 'SJ', 'SE', 'CH',
//   'SY', 'TW', 'TJ', 'TZ', 'TH', 'TL', 'TG', 'TK', 'TO', 'TT', 'TN', 'TR',
//   'TM', 'TC', 'TV', 'UG', 'UA', 'AE', 'GB', 'US', 'UM', 'UY', 'UZ', 'VU',
//   'VE', 'VN', 'VG', 'VI', 'WF', 'EH', 'YE', 'ZM', 'ZW'
// ];

// const countryDisplayNames = typeof Intl !== 'undefined' && Intl.DisplayNames
//   ? new Intl.DisplayNames(['en'], { type: 'region' })
//   : null;

// const countryOptions = countryCodes
//   .map((code) => countryDisplayNames ? countryDisplayNames.of(code) : code)
//   .filter(Boolean)
//   .sort((a, b) => a.localeCompare(b));

export default function HomePage() {

  const [showButtons, setShowButtons] = useState(true);
  const [showForm, setShowForm] = useState(false)
  const [formData, setFormData] = useState({ name: '', email: '', jobTitle: '', company: '' });

  const [submitted, setSubmitted] = useState(false)
  const [selectedSessionKey, setSelectedSessionKey] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [privacyAnchorEl, setPrivacyAnchorEl] = useState(null)

  const isPrivacyPopoverOpen = Boolean(privacyAnchorEl);
  const selectedSession = sessions[selectedSessionKey];
  const selectedSessionDisplay = selectedSession ? formatSession(selectedSession) : null;
  const sessionOptions = Object.values(sessions).map((session) => ({
    ...session,
    display: formatSession(session),
  }));

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    // Add your form submission logic here
    console.log('Form submitted with data:', formData);

    if (!selectedSession) {
      toast.error('Please select a webinar session');
      return;
    }

    const registrationData = {
      name: formData.name.trim(),
      email: formData.email.trim(),
      jobTitle: formData.jobTitle.trim(),
      company: formData.company.trim(),
    };

    if (Object.values(registrationData).some((value) => !value)) {
      toast.error('Please complete all required fields');
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/registrant/add/inPersonRegistrant/?token=${process.env.REACT_APP_API_BASE_TOKEN}`,
        {
          attending: selectedSession.key,
          eventID: selectedSession.eventId,
          ...registrationData,
        }
      );
      console.log('Response from server:', response.data);
      if (response.data.success) {
        setShowForm(false)
        setSubmitted(true)
        // attending === 'sessionOne' ? setSubmitted(true) : setSubmittedVirtual(true)
      } else {
        // setShowForm(false)
        // setSubmitted(true)
        toast.error(response.data.error || response.data.message || 'You have already registered interest in this session')
      }
    } catch (error) {
      // Handle errors
      toast.error(error.response?.data?.error || error.response?.data?.message || 'Something went wrong')
      console.error('Error submitting form:', error);
    } finally {
      setIsSubmitting(false);
    }

  };

  const handleInputChange = async (event) => {

    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handlePrivacyPopoverOpen = (event) => {
    setPrivacyAnchorEl(event.currentTarget);
  };

  const handlePrivacyPopoverClose = () => {
    setPrivacyAnchorEl(null);
  };

  const handleOnBack = () => {
    setShowButtons(true)
    setShowForm(false)
    setSubmitted(false)
    setSelectedSessionKey('')
  }

  const handleSessionOne = () => {
    setSelectedSessionKey('sessionOne')
    setSubmitted(false)
    setShowButtons(false);
    setShowForm(true)
  };

  const handleSessionTwo = () => {
    setSelectedSessionKey('sessionTwo')
    setSubmitted(false)
    setShowButtons(false);
    setShowForm(true)
  }

  /*
  const handleUnabletoAttend = () => {
    setAttending('unabletoattend')
    setSubmitted(false)
    setShowForm(true)
    // setUnableToAttend(true)
    setShowButtons(false)
  }
  */

  return (
    <Box
      //   component="main"
      sx={{
        position: 'relative',
        isolation: 'isolate',
        overflow: 'hidden',
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '100%',
        height: 'auto',
        minHeight: '100vh',
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        display: 'flex',
        padding: '20px 0 20px 0',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {/* <Box
        component="video"
        src={backgroundVideo}
        autoPlay
        muted
        loop
        playsInline
        aria-hidden="true"
        sx={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: -1,
        }}
      /> */}
      <Toaster />
      <CssBaseline />
      <Box
        sx={{
          backgroundColor: 'rgba(255, 255, 255, 0.87)', // Adjust the opacity as needed
          borderRadius: '8px',
          maxWidth: '840px',
          width: { xs: '92%', sm: '86%' },
          height: 'auto',
          maxHeight: 'auto',
          textAlign: 'center',
        }}
      >
        <Box sx={{ background: '', display: 'flex', justifyContent: 'center', alignSelf: 'center', alignItems: 'center', p: 3 }}>
          <img src={logoImage} alt="Logo" style={{ maxWidth: '100%', height: '65px', mixBlendMode: 'multiply' }} />

        </Box>

        <Typography component="h1" sx={{ fontSize: { xs: '1.45rem', sm: '1.85rem' }, fontWeight: 700, px: 3 }}>
          Global Hydrogen Compass 2026: Exclusive CEO Briefing
        </Typography>

        {showButtons && (
          <Stack spacing={2} sx={{ px: { xs: 2.5, sm: 4 }, pt: 3, textAlign: 'left' }}>
            <Typography>
              Join the Hydrogen Council, the world’s largest and only CEO-led hydrogen alliance, for the launch of <em>Global Hydrogen Compass 2026</em>, our flagship annual report providing a fact-based assessment of the progress, challenges and opportunities shaping the global hydrogen industry.
            </Typography>
            <Typography>
              Hear directly from Hydrogen Council Co-Chairs <strong>Jaehoon Chang</strong>, Vice Chair of <strong>Hyundai Motor Group</strong>, and <strong>François Jackow</strong>, CEO of <strong>Air Liquide</strong>, alongside industry CEOs as they discuss the 2026 report’s key findings, latest market developments, and the priorities for scaling hydrogen, globally.
            </Typography>
            <Typography>
              To accommodate audiences across different time zones, the event will be delivered in <strong>two live virtual sessions</strong> on Thursday, 10 September 2026. Both sessions will cover the same report findings while featuring different member CEO speakers and regional perspectives.
            </Typography>
            <Typography sx={{ fontWeight: 600 }}>
              Please register for the session that best suits your time zone.
            </Typography>
          </Stack>
        )}

        {/* <Typography sx={{ fontSize: '1.1rem' }}>
          LOCATION
        </Typography> */}

        <Stack sx={{ p: 3 }}>
          {
            showButtons && <>
              <Typography
                sx={{
                  fontSize: '1.20rem',
                  fontWeight: '200%',
                  '@media (max-width:600px)': {
                    fontSize: '1.1rem', // Adjust the font size for smaller screens
                  },
                }}
              >                    Select a session
              </Typography>
              <Typography sx={{ color: '#59666b', fontSize: '0.88rem', mb: 1 }}>
                Dates and times are shown in your local time zone.
              </Typography>
              <Button onClick={handleSessionOne} sx={{
                background: '#25a5d8', color: 'white', p: 1.5, m: 1.5, borderRadius: '6px', '&:hover': {
                  background: '#707173', cursor: 'pointer'
                }
              }}>
                <Box>
                  <Typography component="span" sx={{ display: 'block', fontWeight: 600 }}>
                    {sessionOptions[0].label}
                  </Typography>
                  <Typography component="span" sx={{ display: 'block', fontSize: '0.85rem' }}>
                    {sessionOptions[0].display.date}
                  </Typography>
                  <Typography component="span" sx={{ display: 'block', fontSize: '0.85rem' }}>
                    {sessionOptions[0].display.time} {sessionOptions[0].display.timezone}
                  </Typography>
                </Box>
              </Button>


              <Button onClick={handleSessionTwo} sx={{
                background: '#25a5d8', color: 'white', p: 1.5, m: 1.5, borderRadius: '6px', '&:hover': {
                  background: '#707173',
                }
              }}>
                <Box>
                  <Typography component="span" sx={{ display: 'block', fontWeight: 600 }}>
                    {sessionOptions[1].label}
                  </Typography>
                  <Typography component="span" sx={{ display: 'block', fontSize: '0.85rem' }}>
                    {sessionOptions[1].display.date}
                  </Typography>
                  <Typography component="span" sx={{ display: 'block', fontSize: '0.85rem' }}>
                    {sessionOptions[1].display.time} {sessionOptions[1].display.timezone}
                  </Typography>
                </Box>
              </Button>


              {/* <Button onClick={handleUnabletoAttend} sx={{
                background: '#25a5d8', color: 'white', p: 1.5, m: 1.5, borderRadius: '15px', '&:hover': {
                  background: '#707173',
                }
              }}>               Unable to attend
              </Button> */}
            </>
          }

          {
            showForm &&
            <Box component="form" onSubmit={handleFormSubmit} sx={{ maxWidth: 520, mx: 'auto' }}>
              {selectedSession && selectedSessionDisplay && (
                <Box sx={{ mb: 1 }}>
                  <Typography sx={{ fontWeight: 600 }}>
                    {selectedSession.label}
                  </Typography>
                  <Typography sx={{ fontSize: '0.9rem' }}>
                    {selectedSessionDisplay.date}
                  </Typography>
                  <Typography sx={{ fontSize: '0.9rem' }}>
                    {selectedSessionDisplay.time} {selectedSessionDisplay.timezone}
                  </Typography>
                </Box>
              )}
              <TextField
                label="Name"
                variant="outlined"
                fullWidth
                margin="normal"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                required
              />
              <TextField
                label="Email"
                variant="outlined"
                fullWidth
                margin="normal"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
              <TextField
                label="Job title"
                variant="outlined"
                fullWidth
                margin="normal"
                name="jobTitle"
                value={formData.jobTitle}
                onChange={handleInputChange}
                required
              />
              <TextField
                label="Company"
                variant="outlined"
                fullWidth
                margin="normal"
                name="company"
                value={formData.company}
                onChange={handleInputChange}
                required
              />
              {/* <TextField
                select
                label="Country"
                variant="outlined"
                fullWidth
                margin="normal"
                name="country"
                value={formData.country}
                onChange={handleInputChange}
                required
              >
                {countryOptions.map((country) => (
                  <MenuItem key={country} value={country}>
                    {country}
                  </MenuItem>
                ))}
              </TextField> */}
              {/* <TextField
                select
                label="Type"
                variant="outlined"
                fullWidth
                margin="normal"
                name="type"
                value={formData.type}
                onChange={handleInputChange}
                required
              >
                {typeOptions.map((type) => (
                  <MenuItem key={type} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </TextField> */}
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5, mt: 1 }}>
                <Typography sx={{ fontSize: '0.9rem' }}>
                  Your details are used to manage your registration, share relevant event updates, and handle your data in line with our <a href={"https://www.brrmedia.co.uk/privacy-policy/"} target="_blank" rel="noopener noreferrer">Privacy Notice</a>.
                </Typography>
                <IconButton
                  aria-describedby={isPrivacyPopoverOpen ? 'privacy-notice-popover' : undefined}
                  aria-label="View privacy notice"
                  onClick={handlePrivacyPopoverOpen}
                  size="small"
                  sx={{ color: '#25a5d8' }}
                >
                  <InfoOutlinedIcon fontSize="small" />
                </IconButton>
              </Box>
              <Popover
                id="privacy-notice-popover"
                open={isPrivacyPopoverOpen}
                anchorEl={privacyAnchorEl}
                onClose={handlePrivacyPopoverClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
              >
                <Typography sx={{ fontSize: '0.9rem', maxWidth: 360, p: 2 }}>
                  (*) For registering to this event, we collect your name, email address, job title and company to manage your participation. The event will be recorded and published on our website. We retain your contact details after the event to send updates about future events and capital markets communications. You can opt out at any time by sending e-mail to: <a href="mailto:info@brrmedia.co.uk" target="_self" rel="noopener noreferrer">info@brrmedia.co.uk</a>. For more details on how we handle your data, your rights and our contact information, please see our full <a href={"https://www.brrmedia.co.uk/privacy-policy/"} target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
                </Typography>
              </Popover>
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <Button onClick={handleOnBack} sx={{ fontSize: '1rem', background: '#25a5d8', color: 'white', p: 1, m: 2, '&:hover': { background: '#707173' } }}>
                  Back
                </Button>

                <Button disabled={isSubmitting} type="submit" sx={{ fontSize: '1rem', background: '#25a5d8', color: 'white', p: 1, m: 2, '&:hover': { background: '#707173' } }}>
                  {isSubmitting ? 'Submitting...' : 'Submit'}
                </Button>

              </Box>
            </Box>
          }

          {
            submitted && selectedSession && selectedSessionDisplay && (
              <>
                <Typography sx={{ fontSize: '1.1rem' }}>
                  Thank you for registering your interest in the {selectedSession.label}.
                </Typography>
                <Typography sx={{ fontSize: '0.95rem', mt: 1 }}>
                  {selectedSessionDisplay.date}, {selectedSessionDisplay.time} {selectedSessionDisplay.timezone}
                </Typography>
                <Typography sx={{ fontSize: '0.95rem', mt: 1 }}>
                  We will confirm your attendance, including sharing a calendar invite and platform access, closer to the event.
                </Typography>
                {/* <Button
                  component="a"
                  href={webcastUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ background: '#25a5d8', color: 'white', p: 1.5, m: 1.5, borderRadius: '15px', '&:hover': { background: '#707173' } }}
                >
                  Access webcast
                </Button> */}
              </>
            )
          }
        </Stack>
      </Box>
    </Box>
  )
}
